import { useEffect, useState } from "react";
import { formatRecentReg, listRecent, normaliseRecentReg } from "../utils/recentRegs";

function ClockIcon({ className, size = 14 }) {
  return (
    <span className={className} aria-hidden="true">
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    </span>
  );
}

export default function RecentRegChips({ brandKey, onSelect, className = "", variant = "sbr" }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(listRecent(brandKey));
  }, [brandKey]);

  if (!items.length) return null;

  return (
    <div
      className={`recent-regs recent-regs--${variant}${className ? ` ${className}` : ""}`}
      role="group"
      aria-label="Recent searches"
    >
      <ClockIcon className="recent-regs-label" />
      {items.map(({ reg }) => {
        const display = formatRecentReg(reg);
        return (
          <button
            key={reg}
            type="button"
            className="recent-regs-chip"
            aria-label={`Check ${display}`}
            onClick={() => onSelect(normaliseRecentReg(reg))}
          >
            {display}
          </button>
        );
      })}
    </div>
  );
}
